import { Box, Typography } from "@mui/material";

import { Scenarii } from "./Scenarii";

import monogram from "../assets/img/monogramBlack.png";

const NotMobile = () => (
  <Box
    sx={{
      width: "100vw",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Typography fontFamily="arial" fontWeight="bold" fontSize="20px">
      Please use your smartphone
    </Typography>
    <Typography fontFamily="arial" fontWeight="bold" fontSize="20px">
      to start the process
    </Typography>
    <img
      src={monogram}
      style={{
        width: "55px",
        margin: "20px",
      }}
    />
  </Box>
);

const Main = () => {
  const isMobileDevice = () => {
    if (typeof window === "undefined") return false;
    const ua = navigator.userAgent || "";
    const isPhone =
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    const isSmallScreen = window.matchMedia("(max-width: 1024px)").matches;
    return isPhone || isSmallScreen;
  };

  return <>{isMobileDevice() ? <Scenarii /> : <NotMobile />}</>;
};

export default Main;
